var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-page-container',[_c('div',{staticClass:"error-page",class:_vm.errorPageClass},[_c('div',{staticClass:"error-page-main"},[_c('p',[_vm._v(_vm._s(_vm.text || _vm.errorText[_vm.code]))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }